<script>
import { mapGetters, mapActions } from "vuex";
import * as Helper from "@/modules/helper/index";
import moment from 'moment'
import groupBy from "lodash.groupby";
import imageUrl from '@/css/images/user-icon.svg'
import DeviceInfo from '@/modules/util/deviceInfo'
import { isPhoneGap } from '@/modules/util/util'

export default {
  props: {
    ChannelDetails: {
      type: Object
    },
    SubscriptionModuleId: {
      type: [String, Number],
      default: 0
    },
    updatemessage: {
      type: Function,
      default: () => {}
    },
    deletemessage: {
      type: Function,
      default: () => {}
    },
    isShowConnectionWarning: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Helper: Helper,
      messages: null,
      dateTime: null,
      pullToRefreshEl: null,
      messagetext: null,
      messageimgArray: [],
      messageimg: '',
      messageid: null,
      messagechannelid: null,
      ptrReloadOn: false,
      isAllLoaded: false,
      isDeleteMessageCalled: false,
      isEditMessageCalled: false,
      isHandleResizeOn: false,
      defaultMessageCount: 0,
      startMessageCount: 0,
      totalMessageCount: 20,
      dataLoaded: false,
      updatingMessages: false
    };
  },
  computed: {
    ...mapGetters([
      "Chat",
      "AppConfig",
      "resource",
      "ChatsUser",
      "ConnectionList",
      "ChannelmsgCount",
      "TypingUsers",
      'ChatHistory',
      'IsReconnecting',
      'getMessageEditingObj',
      'isScrollMessages',
      'isEditMessageViewPortOn',
      'messageTypers'
    ]),
    showTyping () {
      return (this.messageTypers.name !== '')
    },
    chatConnection() {
      return this.ConnectionList.find(c => c.SubscriptionModuleId === this.SubscriptionModuleId)
    },
    ChannelId() {
      // this.setActiveChannelId(this.ChannelDetails.id);
      // console.log("ChannelId", this.ChannelDetails.id);
      return this.ChannelDetails.id;
    },
    UserId() {
      return this.ChatsUser.id;
    },
    ChatHistoryWithDate() {
      let _chatHistory = [];
      const chatHistoryDateWise = groupBy(this.ChatHistory, function (el) {
        let n = el.messageDate.indexOf("Z")
        if (n === -1) {
          el.messageDate = el.messageDate+'Z'
        }
        return moment(el.messageDate).format('YYYY-MM-DD')
      })
      const chatHistoryDate = Object.keys(chatHistoryDateWise)
      chatHistoryDate.forEach(key => {
        _chatHistory.push({'date': key, 'chats': chatHistoryDateWise[key]})
      })
      return _chatHistory
    }
  },
  watch: {
    IsReconnecting(val, oldval) {
      if (val) {
        //console.log('')
        this.dateTime = null
        // this.updatChatHistory([])
        this.initChannelMessages(this.defaultMessageCount, this.totalMessageCount)
        this.setResetReconnectingFlag(false)
        this.$emit('resetDlgProp')
      }
    },
    UserId (val, oldval) {
      if (val !== oldval && val != '') {
        this.dateTime = null
        this.initChannelMessages(this.defaultMessageCount, this.totalMessageCount)
      }
    },
    isEditMessageViewPortOn (val) {
      if (val) {
        this.showEditMessageInViewPort(this.getMessageEditingObj.messageElm)
        this.setResetEditMessageViewPortFlag(false)
      }
    }
    // updatingMessages (val, oldVal) {
    //   this.$nextTick(() => {
    //     let gifMessages = this.$el.querySelectorAll('.chat-img-gif')
    //     gifMessages.forEach((g) => {
    //       let gif = g.querySelector('img')
    //       if (!gif.classList.contains('ff-image')) {
    //         new Freezeframe(gif)
    //       }
    //     })
    //   })
    // },
    // ChatHistory (val, oldVal) {
    //   this.$nextTick(() => {
    //     let gifMessages = this.$el.querySelectorAll('.chat-img-gif')
    //     gifMessages.forEach((g) => {
    //       let gif = g.querySelector('img')
    //       if (!gif.classList.contains('ff-image')) {
    //         new Freezeframe(gif)
    //       }
    //     })
    //   })
    // }
  },

  async created() {
    //console.log('Chat Message Created')
    this.updatChatHistory([])
    await this.initChannelMessages(this.defaultMessageCount, this.totalMessageCount)
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    this.messages = this.$refs.messages.f7Messages
    this.$f7.ptr.create(this.$refs.chatView.$el)
    this.setMessagenode(this.messages)
    let chatView = this.$refs.chatView
    if (chatView) {
      chatView.$el.addEventListener('scroll', this.handleScroll)
    }
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     new Freezeframe(document.querySelectorAll('.message-image'))
    //   }, 500)
    // })
    // setTimeout(() => {
    //   new Freezeframe(document.querySelectorAll('.message-image'))
    // }, 500)
  },
  beforeDestroy() {
    this.setMessagenode(null);
    this.setResetScrollMessageFlag(true)
    this.manageMessageEditing({isEditingOn: false, message: '', messageId: '', channelId: '', messageElm: null})
    this.$f7.dialog.close()
    this.$f7.dialog.destroy()
    this.$f7.popover.close()
    window.removeEventListener('resize', this.handleResize)
    let chatView = this.$refs.chatView
    if (chatView) {
      chatView.$el.removeEventListener('scroll', this.handleScroll)
    }
    if (this.toastTop) this.toastTop.destroy()
    this.setActiveChannelId('')
  },
  methods: {
    ...mapActions([
      "updateUserData",
      "setChannelmsgCount",
      "setMessagenode",
      "setActiveChannelId",
      'updatChatHistory',
      'getChannelMessages',
      'setResetScrollMessageFlag',
      'manageMessageEditing',
      'setResetReconnectingFlag',
      'setResetEditMessageViewPortFlag',
      'getChannelMessageByCount'
    ]),
    setActive (message) {
      return message.banned
    },
    chkGifImage (msgImage, index) {
      let isGIF = false
      if (msgImage !== null) {
        let ext = msgImage.substr(msgImage.lastIndexOf('.') + 1)
        if(ext.toLowerCase() === 'gif') {
          isGIF = true
        }
      }
      return isGIF
    },
    async initChannelMessages (startMessageCount, totalMessageCount) {
      this.dataLoaded = false
      if(this.ChannelId && this.UserId) {
        //this.$showLoader()
        let payload = {
          channelId: this.ChannelId,
          startMessageCount: startMessageCount,
          totalMessageCount: totalMessageCount,
          userId: this.UserId
        }
        await this.getChannelMessageByCount(payload).then(async (response) => {
          if(response.length > 0) {
            let chats = []
            response.forEach(element => {
              let obj = {
                ...element,
                type:
                  this.UserId && this.UserId === element.modulesChatsUsersId
                    ? "sent"
                    : "received",
              };
              chats.push(obj)
            });
            if (chats.length > 0) {
              chats = chats.sort((a, b) => new Date(a.messageDate) - new Date(b.messageDate))
            }
            if (startMessageCount !== this.defaultMessageCount) {
              let chatList = chats.concat(this.ChatHistory)
              chats = chatList
            }
            // if (this.ChatHistory.length > 0) {
            //   this.setResetScrollMessageFlag(false)
            // }
            this.updatingMessages = true
            this.updatChatHistory(chats)
            this.dataLoaded = true
            this.$nextTick(() => {
              this.updatingMessages = false
            })
          } else {
            this.dataLoaded = true
            this.isAllLoaded = true
          }
        }).catch(err => {
          //this.$hideLoader()
          console.log('get err', err)
        })
      } else {
        this.dataLoaded = true
      }
    },
    handleResize () {
      if (this.messages && (!this.getMessageEditingObj.isEditingOn || this.isHandleResizeOn) && !this.isDeleteMessageCalled && !this.isEditMessageCalled) {
        this.messages.scroll(0, this.messages.$el[0].scrollHeight)
      }
      this.isDeleteMessageCalled = false
      this.isEditMessageCalled = false
      this.isHandleResizeOn = false
    },
    getUserImage(message) {
      if(message.type === 'sent') {
        return ''
      } else if(!Helper.IsNullOrEmpty(message.userImage)) {
        return this.AppConfig.Urls.ContentAssetsBaseUrl+message.userImage
      } else {
        return imageUrl
      }
    },
    channelDetailUrl: function(value) {
      return "/chat-detail-view/" + this.SubscriptionModuleId + "/" + value;
    },
    isFirstMessage(message, index, chats) {
      const previousMessage = chats[index - 1];
      if (message.isTitle) return false;
      if (
        !previousMessage ||
        previousMessage.type !== message.type ||
        previousMessage.userName !== message.userName
      )
        return true;
      return false;
    },
    isLastMessage(message, index, chats) {
      const nextMessage = chats[index + 1];
      if (message.isTitle) return false;
      if (
        !nextMessage ||
        nextMessage.type !== message.type ||
        nextMessage.userName !== message.userName
      )
        return true;
      return false;
    },
    isTailMessage(message, index, chats) {
      const nextMessage = chats[index + 1];
      if (message.isTitle) return false;
      if (
        !nextMessage ||
        nextMessage.type !== message.type ||
        nextMessage.userName !== message.userName
      )
        return true;
      return false;
    },
    lessThan5min (date) {
      return moment(date).isAfter(moment().subtract(5, 'minute'));
    },
    getMessageTime(date) {
      let time = ''
      let dt = new Date(date)
      let curTime = new Date()
      let diff = curTime.getTime() - dt.getTime()
      if (diff < 60000) { // 1000 milliseconds
        return this.resource.str_justNow;
      }
      else if (diff > 60000 && diff < 120000) {
        return this.resource.str_1_min;
      }
      else if (diff < 120000 && diff < 180000) {
        return this.resource.str_2_min;
      }
      else if (diff < 180000 && diff < 240000 ) {
        return this.resource.str_3_min;
      }
      else if (diff < 240000 && diff < 300000) {
        return this.resource.str_4_min;
      }
      else if (diff > 300000 && diff <360000) {
        return this.resource.str_5_min;
      }
      else {
        time = Helper.ConvertToMyZoneUtc(date).format('HH:mm')
      }
      return time;
    },
    formatChatDate(date) {
      if (Helper.FormattedDateDDMMMMYY(date) === Helper.FormattedDateDDMMMMYY(Helper.CurrentDateTime().add(-1, 'days'))) {
        return this.resource.yesterday
      }
      if (Helper.FormattedDateDDMMMMYY(date) === Helper.FormattedDateDDMMMMYY(Helper.CurrentDateTime())) {
        return this.resource.today
      }
      return Helper.FormattedDateDDMMMMYY(date)
    },
    onPTRStart () {
      if (isPhoneGap() && Keyboard) {
        Keyboard.hide()
      }
    },
    async ptrReloadChat () {
      if(!this.ptrReloadOn) {
        this.setResetScrollMessageFlag(false)
        this.ptrReloadOn = true
        this.startMessageCount += this.totalMessageCount + 1
        await this.initChannelMessages(this.startMessageCount, this.totalMessageCount)
        this.ptrReloadOn = false
        this.$f7.ptr.done()
        if (this.isAllLoaded) {
          if (!this.toastTop) {
            this.toastTop = this.$f7.toast.create({
              text: this.resource.noResultMsg,
              position: 'top',
              closeTimeout: 2000,
            });
          }
          this.toastTop.open();
        }
      }
    },
   handleDeletemessage(messagetext,messageid, channelid) {
      let that = this
      this.$f7.popover.close()
      this.$f7.dialog.create({
        title: '',
        text: this.resource.deleteChatMessage,
        buttons: [
          {
            text: that.resource.OkBtn,
            bold: true,
            onClick: function() {
              that.deleteOkCallback(messagetext,messageid, channelid)
            }
          },
          {
            text: that.resource.cancelBtn,
            bold: true
          }
        ]
      }).open()
    },
    handleDeleteImage(messagetext,messageid, channelid) {
      let that = this
      this.$f7.popover.close()
       this.$f7.dialog.create({
        title: '',
        text: this.resource.deleteChatMessageImg,
        buttons: [
          {
            text: that.resource.OkBtn,
            bold: true,
            onClick: function() {
              that.deleteOkCallback(messagetext, messageid, channelid)
            }
          },
          {
            text: that.resource.cancelBtn,
            bold: true
          }
        ]
      }).open()
      // this.$f7.dialog.confirm(this.resource.deleteChatMessageImg, '', this.deleteOkCallback.bind(this, messagetext,messageid, channelid))
    },
    deleteOkCallback (messagetext,messageid, channelid) {
      this.$showLoader()
      this.isDeleteMessageCalled = true
      this.setResetScrollMessageFlag(false)
      this.manageMessageEditing({isEditingOn: false, message: '', messageId: '', channelId: '', messageElm: null})
      this.deletemessage(messagetext,messageid, channelid)
      setTimeout(() =>
        this.$hideLoader()
        , 3000)
    },
    handleUpdatemessage (messagetext, messageid, channelid, messageElm) {
      this.$f7.popover.close()
      this.setResetScrollMessageFlag(false)
      this.$emit('onMessageEdit',{isEditingOn: true, message: messagetext, messageId: messageid, channelId: channelid, messageElm: messageElm})
    },
    onclosepb (img) {
      let r = this.AppConfig.Urls.ContentAssetsBaseUrl+this.messageimg
      const index =  this.messageimgArray.indexOf(r);
      this.messageimgArray.splice(index, 1)[0];
    },
    viewPhotoArray(img) {
      let r = this.AppConfig.Urls.ContentAssetsBaseUrl+img
      this.messageimgArray.unshift(r)
      this.$refs.standaloneDark.open()
    },
    handleTapHold (e, text, id, channelid, chatsUsersId, img) {
      this.isEditMessageCalled = true
      if((this.UserId !== chatsUsersId || !this.isShowConnectionWarning) && (img &&  img.length > 0)) {
        this.viewPhotoArray(img)
        return
      }
      if(this.UserId !== chatsUsersId || this.isShowConnectionWarning)
        return
      this.messageElm = e.srcElement
      this.messagetext = text
      this.messageid = id
      this.messagechannelid = channelid
      this.$f7.popover.open(this.$refs.tapholdPopover.$el, e.srcElement, true)
      let dlgTop = parseInt(this.$refs.tapholdPopover.$el.style.top)
      if (dlgTop < 45) {
        this.$refs.tapholdPopover.$el.style.top = dlgTop + (45 - dlgTop) + 'px'
      }
    },
    handleTapHoldImage (e, text, id, channelid, chatsUsersId) {
      event.stopPropagation()
      if(this.UserId !== chatsUsersId || this.isShowConnectionWarning)
        return
      this.messageElm = e.srcElement
      this.messagetext = text
      this.messageid = id
      this.messagechannelid = channelid
      this.$f7.popover.open(this.$refs.tapholdPopoverimg.$el, e.srcElement, true)
      let dlgTop = parseInt(this.$refs.tapholdPopoverimg.$el.style.top)
      if (dlgTop < 45) {
        this.$refs.tapholdPopoverimg.$el.style.top = dlgTop + (45 - dlgTop) + 'px'
      }
    },
    showEditMessageInViewPort (messageElm) {
      if (isPhoneGap() && messageElm) {
        var offsetObj = messageElm.getBoundingClientRect()
        let stdHeight = parseInt(window.innerHeight / 2)
        if (((offsetObj.top + messageElm.offsetHeight) > stdHeight) || offsetObj.top < 0) {
          let scrollDiv = this.messages.pageContentEl
          let scrollPos = (scrollDiv.scrollTop + ((offsetObj.top + messageElm.offsetHeight) - stdHeight) + messageElm.offsetHeight)
          if ((scrollDiv.scrollTop + offsetObj.top + stdHeight) >= scrollDiv.scrollHeight) {
            this.isHandleResizeOn = true
            this.isEditMessageCalled = false
          } else {
            this.messages.scroll(0, scrollPos)
          }
        }
      }
    },
    imageUrl(img) {
      return this.AppConfig.Urls.ContentAssetsBaseUrl + img
      },
    handleScroll () {
      this.$f7.popover.close()
    }
  }
};
</script>
<template>
  <f7-page-content
    ref="chatView"
    v-if="ChannelDetails"
    ptr :ptr-distance="75"
    @ptr:refresh="ptrReloadChat"
    @ptr:pullstart="onPTRStart"
    class="page-content-custom">
    <f7-messages ref="messages"
      :scroll-messages="isScrollMessages">
      <template v-if="dataLoaded && ChatHistoryWithDate.length == 0">
        <div v-if="UserId === ''" class="errorMessage">
          <span>{{resource.emptyChatRegisterErrorMsg}}</span>
        </div>
        <div v-else class="errorMessage">
          <span>{{resource.emptyChatErrorMsg}}</span>
        </div>
      </template>
      <template  v-else-if="!updatingMessages" v-for="(dateObj, index) in ChatHistoryWithDate">
        <f7-messages-title :key="index">{{formatChatDate(dateObj.date)}}</f7-messages-title>
        <f7-message
          v-for="(message, index1) in dateObj.chats"
          :key="index1+'-'+index"
          :type="message.type"
          :image="message.messageImage !== null ? imageUrl(message.messageImage) : message.messageImage"
          :name="message.type === 'sent' ? '' : message.userName"
          :color="message.rowDeleted || message.hideMessage ? 'gray' : ''"
          class="message-description"
          :class="{'chat-img-wrapper': message.messageImage !== null}"
          :text="message.rowDeleted ? resource.deletedmsg : message.hideMessage ? resource.hiddenmsg : message.messageText"
          :avatar="getUserImage(message)"
          :first="isFirstMessage(message, index1, dateObj.chats)"
          :last="isLastMessage(message, index1, dateObj.chats)"
          :tail="isTailMessage(message, index1, dateObj.chats)"
          :text-header="getMessageTime(message.messageDate)"
          @click="!(message.rowDeleted || message.hideMessage) ? handleTapHold($event,message.messageText,message.id,message.modulesChatsChannelsId,message.modulesChatsUsersId, message.messageImage) : ''">
        <div slot="content-start" class="moreoption" v-if="message.modulesChatsUsersId === UserId && message.messageImage" @click="handleTapHoldImage($event,message.messageText,message.id,message.modulesChatsChannelsId,message.modulesChatsUsersId, message.messageImage)"></div>
        </f7-message>
      </template>
      <f7-photo-browser
        @photobrowser:close ="onclosepb(messageimg)"
        :photos="messageimgArray"
        theme="dark"
        ref="standaloneDark"
      ></f7-photo-browser>
      <!-- <f7-message v-show="showTyping"
        type="received"
        :typing="true"
        :first="true"
        :last="true"
        :tail="true"
        :header="`${messageTypers.name} is typing`"
        :avatar="messageTypers.avatar"
      ></f7-message> -->
    </f7-messages>
    <f7-popover ref="tapholdPopover" class="popovercustom">
      <f7-row>
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="updatemessage" @click="handleUpdatemessage(messagetext,messageid, messagechannelid, messageElm)">{{resource.editMsgBtn}}</div>
              <div class="deletemessage" @click="handleDeletemessage(messagetext,messageid, messagechannelid)">{{resource.deleteMsgBtn}}</div>
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>
    </f7-popover>
    <f7-popover ref="tapholdPopoverimg" class="popovercustom">
      <f7-row>
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="deletemessage" @click="handleDeleteImage(messagetext,messageid, messagechannelid)">{{resource.deleteMsgBtn}}</div>
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>
    </f7-popover>
  </f7-page-content>
</template>

<style scoped>
  .message-description {
    white-space: pre-line;
  }
  .ios .messages-content, .ios .messages {
    background: transparent;
  }
  .md .messages {
    background: transparent;
  }
  .delete-message,.update-message{
    height: 21px;
    width: 21px;
    float: left;
    margin: 0 5px 5px;
    background-size: contain;
  }
  .deletemessage,.updatemessage{
    background: #ffffff;
    height: 30px;
    text-align: center;
    padding:10px 0;
    font-size:17px;
  }
  .message-input >>> textarea {
    padding: 5px;
    width: 100%;
    max-height: 200px;
  }
  .page-content-custom {
    flex: 1;
    padding-bottom: 0!important;
  }
  .ios .item-input-wrap {
    margin-top: 0;
    margin-bottom: 0;
  }
  .popovercustom {
    width: 160px;
  }
  .errorMessage {
    font-size: 16px;
    margin: auto;
    color: gray;
    text-align: center;
    padding:15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatNew.vue